import { render } from "./PanelErrores.vue?vue&type=template&id=d9ff3d28&scoped=true"
import script from "./PanelErrores.vue?vue&type=script&lang=js"
export * from "./PanelErrores.vue?vue&type=script&lang=js"

import "./PanelErrores.vue?vue&type=style&index=0&id=d9ff3d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ff3d28"]])

export default __exports__